<div class="container mt-5">
  
    <h2>Payment History</h2>
    
    <table class="table table-striped">
      <thead>
          <tr>
            <th>Id</th>
            <th>Name</th>
            <th>Username</th>
            <th>Email</th>
            <th>Payment</th>
          </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of Users">
          <td>{{ user.id }}</td>
          <td>{{ user.name }}</td>
          <td>{{ user.username }}</td>
          <td>{{ user.email }}</td>
          <td>{{ user.payment }}</td>
        </tr>
      </tbody>
    </table>
  </div>